import React from 'react';
import { motion } from 'framer-motion';

const Loader = ({ size = 50, color = "#06AED5", thickness = 2 }) => {
    return (
        <motion.div
            style={{
                width: size,
                height: size,
                border: `${thickness}px solid transparent`, // Fully transparent base
                borderTop: `${thickness}px solid ${color}`, // Main colored section
                borderRight: `${thickness}px solid ${color}`, // Extend color for longer trail
                borderRadius: '50%',
            }}
            animate={{
                rotate: 360
            }}
            transition={{
                duration: 1,
                repeat: Infinity,
                ease: "linear"
            }}
        />
    );
};

export default Loader;
